import { router } from '@inertiajs/react'
import { ClipboardList } from 'lucide-react'

interface Props {
  show: boolean
}

export default function FfrRegistrationNotice({ show }: Props) {
  if (!show) return null

  const handleComplete = () => {
    router.post('/my/ffr_registration/complete', {}, { preserveScroll: true })
  }

  return (
    <div className="card border-l-4 border-l-chestnut-gold bg-amber-50">
      <div className="flex items-start gap-3">
        <ClipboardList className="h-6 w-6 mt-0.5 flex-shrink-0 text-chestnut-gold" />
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-semibold text-chestnut-charcoal font-heading">
            Complete your FFR Registration
          </h2>
          <p className="text-sm text-chestnut-charcoal/80 mt-1">
            You will need to complete your FFR registration before you complete any contracting or
            submit any business at{' '}
            <a
              href="https://ffr.formstack.com/forms/ffr_sub_agent_intake_form"
              target="_blank"
              rel="noopener noreferrer"
              className="text-chestnut-forest font-medium underline break-all"
            >
              https://ffr.formstack.com/forms/ffr_sub_agent_intake_form
            </a>
          </p>
          <div className="mt-4">
            <button
              type="button"
              onClick={handleComplete}
              className="inline-flex items-center px-4 py-2 rounded-lg bg-chestnut-forest text-white text-sm font-medium hover:bg-chestnut-forest/90"
            >
              Complete this
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
